export const ENGINEER_VISIT_ACCORDION_TITLE = {
  before: 'Before your engineer visit',
  during: 'During your engineer visit',
  missed: 'Missing an engineer visit',
};

export const ENGINEER_VISIT_LEARN_MORE = 'Learn more about your engineer visit';
